export default "__VITE_ASSET__D0iwSPkS__"